/**
 * Single source for crawl + social metadata. Keep `public/index.html` titles/descriptions
 * aligned when you change primary copy here (initial HTML is what non-JS crawlers see first).
 */
export const SITE_URL = 'https://crimsonarctechnologies.online';

export const SITE_NAME = 'CrimsonArc Technologies';

export const DEFAULT_TITLE =
  'CrimsonArc Technologies — IT Solutions & Custom Software | Nigeria & Africa';

export const DEFAULT_DESCRIPTION =
  'CrimsonArc Technologies (Crimson Arc) builds enterprise software, custom platforms, and IT solutions for teams in Nigeria, Africa, and globally. Cloud, offline, and hybrid deployment; estate, accounting, and industry-specific systems.';

/** Natural-language phrases; useful for Bing/DDG and internal consistency (Google largely ignores keywords meta). */
export const KEYWORD_PHRASES = [
  'Crimson Arc',
  'CrimsonArc',
  'CrimsonArc Technologies',
  'software companies in Africa',
  'software companies in Nigeria',
  'enterprise software solution providers',
  'custom software development Nigeria',
  'IT solutions Africa',
  'enterprise software Africa',
  'business software Nigeria',
  'hybrid cloud software',
  'offline-first enterprise apps',
];

export const ALTERNATE_ORG_NAMES = [
  'Crimson Arc',
  'CrimsonArc',
  'CrimsonArc Technologies',
  'Crimson Arc Technologies',
];

export const KNOWS_ABOUT = [
  'Enterprise software',
  'Custom software development',
  'IT consulting',
  'Cloud applications',
  'Offline-first software',
  'Estate management software',
  'Accounting software',
  'System integration',
];

export const CONTACT_EMAIL = 'hello@crimsonarctechnologies.online';

/** Public path to the social / logo lockup asset (PNG). */
export const OG_IMAGE_PATH = '/crimsonarc-lockup.png';

/** Absolute URL for Open Graph, Twitter, JSON-LD logo (raster recommended for social crawlers). */
export const OG_IMAGE_URL = `${SITE_URL}${OG_IMAGE_PATH}`;

/** Pixel size of `crimsonarc-lockup.png` — keep in sync if you replace the file. */
export const OG_IMAGE_WIDTH = 1376;
export const OG_IMAGE_HEIGHT = 768;
